<div class="job-order-container">
    <app-vertical-tabs
      [tabs]="tabList"
      (tabSelected)="selectTab($event)"
    ></app-vertical-tabs>
  
    <div
      class="section jo-details-section card-layout"
      [hidden]="selectedTab !== 'basicDetailsSection'"
    >
      <app-dynamic-form [formConfig]="dynamicForm" [formGroup]="jobOrderForm">
        >
      </app-dynamic-form>
    </div>
  
    <div class="section card-layout" [hidden]="selectedTab !== 'cargoSection'">

        <div class="table-actions">
            <div class="left">
                <div class="search-bar"  *ngIf="!viewMode">
                    <div class = "field-group">
                        <label for="documentType">Document Type</label>
                        <app-multi-select
                        id="documentType"
                        [options]="documentTypeList"
                        [displayKey]="'value'"
                        [valueKey]="'key'"
                        [isMultiSelect]="false"
                        (selectionChange)="onCargoDocumentTypeSelection($event)"
                        [placeholder]="'Select Document Type'"
                        ></app-multi-select>
                    </div>
        
                    <div class = "field-group">
                        <label for="documentNo">Document No</label>
                        <app-autocomplete-dropdown
                        id="documentNo"
                        class = "autocomplete-dropdown"
                        [(ngModel)] = "searchQuery"
                        [placeholder]="'Enter Document No'"
                        [apiUrl]="selectedCargoDocumentType?.lookupDetails?.apiUrl"
                        [filterByKeys]="selectedCargoDocumentType?.lookupDetails?.filterByKeys"
                        [limit]="10"
                        [orderBy]="selectedCargoDocumentType?.lookupDetails?.orderBy"
                        [bindLabel]="selectedCargoDocumentType?.lookupDetails?.bindLabel"
                        [bindValue]="selectedCargoDocumentType?.lookupDetails?.bindValue"
                        [displayColumns]="selectedCargoDocumentType?.lookupDetails?.displayColumns"
                        (suggestionSelected) = "onSearchSelection($event)"
                        (searchCleared)="clearSearch()"
                        >
                    </app-autocomplete-dropdown>
                    </div>
        
                    <div class = "button-wrapper">
                        <button class="add-inventory-btn secondary_button" (click)="fetchCargo()">Fetch Items</button>
                    </div>
                </div>
            </div>

            <div class="right" *ngIf="!viewMode">
                <button
                  type="button"
                  class="manage-service-button secondary_button"
                  (click)="configureServiceForCargo()"
                >
                  <app-svg-icon
                    class="image-icon"
                    [path]="'assets/icons/add_plus_icon.svg'"
                  ></app-svg-icon>
                  <span>Add Services</span>
                </button>
            </div>
        </div>

        <app-accordion-table
        #cargoTableAccordion
        [readOnly]="viewMode"
        [noDataMsg]="'No Items added'"
        [noDataIconPath]="'assets/images/no-data-new.svg'"
        [(tableHeaderAndData)]="cargoTableData"
        (onAccordionOpen)="loadTableAccordion($event, 'CARGO')"
        (onItemDeletion)="handleCargoDeletion($event)"
      ></app-accordion-table>
    </div>
  
    <div class="section card-layout" [hidden]="selectedTab !== 'containerSection'">
        
        <div class="table-actions">
            <div class="left" *ngIf="!viewMode">
                <div class="search-bar">
                    <div class = "field-group">
                        <label for="documentType">Document Type</label>
                        <app-multi-select
                        id="documentType"
                        [options]="documentTypeList"
                        [displayKey]="'value'"
                        [valueKey]="'key'"
                        [isMultiSelect]="false"
                        (selectionChange)="onContainerDocTypeSelection($event)"
                        [placeholder]="'Select Document Type'"
                        ></app-multi-select>
                    </div>
        
                    <div class = "field-group">
                        <label for="documentNo">Document No</label>
                        <app-autocomplete-dropdown
                        id="documentNo"
                        class = "autocomplete-dropdown"
                        [(ngModel)] = "searchQuery"
                        [placeholder]="'Enter Document No'"
                        [apiUrl]="selectedContainerDocumentType?.lookupDetails?.apiUrl"
                        [filterByKeys]="selectedContainerDocumentType?.lookupDetails?.filterByKeys"
                        [limit]="10"
                        [orderBy]="selectedContainerDocumentType?.lookupDetails?.orderBy"
                        [bindLabel]="selectedContainerDocumentType?.lookupDetails?.bindLabel"
                        [bindValue]="selectedContainerDocumentType?.lookupDetails?.bindValue"
                        [displayColumns]="selectedContainerDocumentType?.lookupDetails?.displayColumns"
                        (suggestionSelected) = "onSearchSelection($event)"
                        (searchCleared)="clearSearch()"
                        >
                    </app-autocomplete-dropdown>
                    </div>
        
                    <div class = "button-wrapper">
                        <button class="add-inventory-btn secondary_button" (click)="fetchContainer()">Fetch Containers</button>
                    </div>
                </div>
            </div>

            <div class="right" *ngIf="!viewMode">
                <button
                  type="button"
                  class="manage-service-button secondary_button"
                  (click)="configureServiceForContainer()"
                >
                  <app-svg-icon
                    class="image-icon"
                    [path]="'assets/icons/add_plus_icon.svg'"
                  ></app-svg-icon>
                  <span>Add Services</span>
                </button>
            </div>
        </div>

        <app-accordion-table
        #containerTableAccordion
        [readOnly]="viewMode"
        [noDataMsg]="'No Containers added'"
        [noDataIconPath]="'assets/images/no-data-new.svg'"
        [(tableHeaderAndData)]="containerTableData"
        (onAccordionOpen)="loadTableAccordion($event, 'CONTAINER')"
        (onItemDeletion)="handleContainerDeletion($event)"
        ></app-accordion-table>
    </div>
  </div>
  